'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _stateStore = require('./state-store');

var _stateStore2 = _interopRequireDefault(_stateStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * A StateController manages state for an application or component
 * Subclasses extend this and expose methods that call the controller's _update method
 * Controller will default create its own state store unless one is passed.
 * StateController subclasses should only accept the dependencies they need via constructor
 * This means the dependencies can easily be mocked and unit tested
 */
var StateController = function () {
  // Create's a default store if one isn't given
  function StateController() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$store = _ref.store,
        store = _ref$store === undefined ? null : _ref$store;

    _classCallCheck(this, StateController);

    this._store = store || new _stateStore2.default();
    this._update(this.defaultState);
  }

  _createClass(StateController, [{
    key: '_update',


    // Discourage external users from using state directly
    value: function _update(props) {
      this._store.update(props);
    }
  }, {
    key: 'subscribeUpdates',
    value: function subscribeUpdates(listener) {
      return this._store.subscribeUpdates(listener);
    }
  }, {
    key: 'unsubscribeUpdates',
    value: function unsubscribeUpdates(listener) {
      return this._store.unsubscribeUpdates(listener);
    }
  }, {
    key: 'defaultState',
    get: function get() {
      return {};
    }
  }, {
    key: 'state',
    get: function get() {
      return this._store.state;
    }
  }]);

  return StateController;
}();

exports.default = StateController;